import React from "react";
import styles from "./ColorPicker.module.scss";
import { HexAlphaColorPicker } from "react-colorful";
import { useDispatch, useSelector } from "react-redux";
import { setNewWidget } from "../../store/slices/widgetSlice";
import "./ColorPicker.css";

const ColorPicker = ({ data }) => {
  const dispatch = useDispatch();

  const { newWidget } = useSelector((state) => state?.widget);

  const handleColorChange = (color, type) => {
    if (newWidget) {
      const updatedWidget = { ...newWidget, [type]: color };
      dispatch(setNewWidget(updatedWidget));
    }
  };

  const handlerInput = (e) => {
    if (newWidget) {
      let res = JSON.parse(JSON.stringify(newWidget));

      Object.defineProperty(res, e.target.name, {
        value: e.target.value,
      });

      dispatch(setNewWidget(res));
    }
  };

  return (
    <div className={styles.colorPicker}>
      <div className={styles.colorPickerTitle}>Выберите цвета для виджета</div>
      <div className={styles.colorPickerItemContainer}>
        <div className={styles.colorPickerItem}>
          <div className={styles.colorPickerTitleS}>Цвет фона</div>
          <div className="customLayoutPicker">
            <HexAlphaColorPicker
              color={newWidget ? newWidget.backgroundColor : ""}
              onChange={(color) => handleColorChange(color, "backgroundColor")}
            />
          </div>
          <div className={styles.colorPickerValuesContainer}>
            <div className={styles.colorPickerInputContainer}>
              <div className={styles.colorPickerInputTitle}>HEX:</div>
              <input
                className={styles.colorPickerInput}
                name={"backgroundColor"}
                value={newWidget ? newWidget.backgroundColor : ""}
                onChange={handlerInput}
              />
            </div>
          </div>
        </div>
        <div className={styles.colorPickerItem}>
          <div className={styles.colorPickerTitleS}>Цвет текста</div>
          <div className="customLayoutPicker">
            <HexAlphaColorPicker
              color={newWidget ? newWidget.textColor : ""}
              onChange={(color) => handleColorChange(color, "textColor")}
            />
          </div>
          <div className={styles.colorPickerValuesContainer}>
            <div className={styles.colorPickerInputContainer}>
              <div className={styles.colorPickerInputTitle}>HEX:</div>
              <input
                className={styles.colorPickerInput}
                name={"textColor"}
                value={newWidget ? newWidget.textColor : ""}
                onChange={handlerInput}
              />
            </div>
          </div>
        </div>
        <div className={styles.colorPickerItem}>
          <div className={styles.colorPickerTitleS}>Основной цвет</div>
          <div className="customLayoutPicker">
            <HexAlphaColorPicker
              color={newWidget ? newWidget.color : ""}
              onChange={(color) => handleColorChange(color, "color")}
            />
          </div>
          <div className={styles.colorPickerValuesContainer}>
            <div className={styles.colorPickerInputContainer}>
              <div className={styles.colorPickerInputTitle}>HEX:</div>
              <input
                className={styles.colorPickerInput}
                name={"color"}
                value={newWidget ? newWidget.color : ""}
                onChange={handlerInput}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ColorPicker;
